<template>
     <avue-crud
        ref="avueCrud"
        :data="tableData"
        :option="option"
        v-model="form"
        :table-loading="TABLE_LOADING"
        :page.sync="TABLE_PAGE"
        @search-change="SEARCH_CHANGE"
        @refresh-change="TABLE_REFRESH"
        @search-reset="SEARCH_RESET"
        @cell-click="CELL_CLICK"
        @selection-change="SELECTION_CHANGE"
        @sort-change="SORT_CHANGE"
        @size-change="SIZE_CHANGE"
        @current-change="CURRENT_CHANGE"
        :before-open="beforeOpen"
        :before-close="beforeClose"
        @row-update="rowUpdate"
        @row-save="rowSave"
        @row-del="rowDel"
      >
      <template slot-scope="scope" slot="menuLeft">
        <el-button type="primary"
        icon="el-icon-plus"
        size="small"
        v-if="constaddBtn"
        @click.stop="handleAdd()">新增任务</el-button>
    </template>
    <template slot="rwzt" slot-scope="scope" >
         <el-switch v-model=scope.row.rwzt @change="changezt(scope)"   active-value="1" inactive-value="2" :disabled="switchdisabled"></el-switch>
    </template>
     </avue-crud>
</template>
<script>
import { getDictionary } from '@/businessManagement/utils/jwTools.js'
import crudPageMinix from '@/businessManagement/utils/crudPageMinix.js'
export default {
  mixins: [crudPageMinix],
  data() {
    return {
      switchdisabled: true,
      constaddBtn: false,
      dialogVisible: false,
      msg: '',
      option: {
        stripe: true,
        border: true,
        page: true,
        align: 'left',
        menuAlign: 'center',
        menuWidth: 80,
        searchMenuSpan: 6,
        index: true,
        indexLabel: '序号',
        columnBtn: false,
        refreshBtn: true,
        // labelWidth: 150,
        viewBtn: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: '主任务名称',
            prop: 'yjrwmc',
            search: true,
            searchLabelWidth: 90,
            labelWidth: 100,
            rules: [
              {
                required: true,
                message: '请输入主任务名称',
                trigger: 'blur'
              }
            ]
          },
          {
            label: '任务类型',
            prop: 'rwlx',
            search: true,
            type: 'select',
            dicData: [],
            minWidth: 30,
            rules: [
              {
                required: true,
                message: '请选择任务类型',
                trigger: 'change'
              }
            ]
          },
          {
            label: '任务周期',
            prop: 'rwzq',
            search: true,
            type: 'select',
            dicData: [],
            minWidth: 30,
            rules: [
              {
                required: true,
                message: '请选择任务周期',
                trigger: 'change'
              }
            ]
          },
          {
            label: '所属部门',
            prop: 'orgId',
            type: 'select',
            search: true,
            dicData: [],
            props: {
              label: 'name',
              value: 'id'
            },
            rules: [
              {
                required: true,
                message: '请选择所属部门',
                trigger: 'change'
              }
            ]
          },
          {
            label: '负责人',
            prop: 'yjrwfzr',
            search: true,
            minWidth: 40,
            rules: [
              {
                required: true,
                message: '请输入负责人',
                trigger: 'blur'
              }
            ]
          },
          {
            label: '创建人',
            prop: 'xm',
            addDisplay: false,
            minWidth: 30,
            editDisabled: true
          },
          {
            label: '创建时间',
            prop: 'createTime',
            addDisplay: false,
            minWidth: 50,
            editDisabled: true
          },
          {
            label: '状态',
            prop: 'rwzt',
            type: 'select',
            slot: true,
            search: true,
            minWidth: 30,
            addDisplay: false,
            editDisabled: true,
            dicData: [
              {
                label: '正常',
                value: '1'
              },
              {
                label: '关闭',
                value: '2'
              }
            ]
          }
        ]
      },
      tableData: [],
      form: {}
    }
  },
  mounted() {
    this.$http.post('/fighter-uaap-manage/org/list', {
      'entity': {
        status: '1',
        parentPermissionSubjectId: '1'
      },
      downwardRecursive: true
    }).then(response => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'orgId', 'prop')
        ],
        'dicData',
        response.data
      )
    })
    getDictionary('RWLX').then((dic) => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'rwlx', 'prop')
        ],
        'dicData',
        dic
      )
    })
    getDictionary('RWZQ').then((dic) => {
      this.$set(
        this.option.column[
          this.findArray(this.option.column, 'rwzq', 'prop')
        ],
        'dicData',
        dic
      )
    })
    let LoginName = this.$store.getters.userInfo.subject.roleList.map(
      item => item.roleCode
    )
    if (
      LoginName.indexOf('2454928040') !== -1
    ) {
      this.option.delBtn = true
      this.option.editBtn = true
      this.option.menuWidth = 200
      this.constaddBtn = true
      this.switchdisabled = false
    }
    this.loadData()
  },
  methods: {
    loadData(
      TABLE_PAGE = this.TABLE_PAGE,
      QUERY_CONDITIONS = this.QUERY_CONDITIONS,
      TABLE_ORDER = this.TABLE_ORDER,
      done
    ) {
      this.TABLE_LOADING = true // 表格转圈
      this.$http.post('/fighter-workflow-saas/RwManage/queryYjrw',
        QUERY_CONDITIONS,
        {
          params: {
            pageNum: TABLE_PAGE.currentPage,
            pageSize: TABLE_PAGE.pageSize
          }
        })
        .then((response) => {
          this.RELOAD_CRUD(response.data.records)
          this.TABLE_PAGE.total = response.data.total || response.data.records.length
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message)
        })
        .finally(() => {
          this.TABLE_LOADING = false // 表格转圈
          typeof done === 'function' && done()
        })
    },
    handleAdd() {
      this.$refs.avueCrud.rowAdd()
    },
    changezt(scope) {
      // this.rowUpdate(scope.row, scope.row.$index)
      if (scope.row.wgbEjrws <= 0) {
        // this.$message.success('编辑数据' + JSON.stringify(form) + '数据序号' + index)
        this.closeRw(scope.row.id, scope.row.rwzt)
      } else {
        let msg = '当前任务有未关闭二级任务数' + scope.row.wgbEjrws + '条，确认关闭？'
        this.$confirm(msg)
          .then(_ => {
            this.closeRw(scope.row.id, scope.row.rwzt)
            this.loadData()
          })
          .catch(_ => {
            this.loadData()
          })
      }
    },
    rowSave(form, done) {
      var formData = new window.FormData()
      formData.append('yjrwmc', form.yjrwmc)
      formData.append('yjrwfzr', form.yjrwfzr)
      formData.append('rwlx', form.rwlx)
      formData.append('rwzq', form.rwzq)
      formData.append('orgId', form.orgId)
      this.$http.post('/fighter-workflow-saas/RwManage/insertYjrw', formData)
        .then(response => {
          this.$message.success('新增一级任务成功！')
          this.loadData()
          done()
        })
    },
    rowUpdate(form, index, done, loading) {
      var formData = new window.FormData()
      formData.append('id', form.id)
      formData.append('rwlx', form.rwlx)
      formData.append('rwzq', form.rwzq)
      formData.append('yjrwfzr', form.yjrwfzr)
      formData.append('yjrwmc', form.yjrwmc)
      formData.append('orgId', form.orgId)
      this.$http.post('/fighter-workflow-saas/RwManage/updateYjrwxx', formData).then(response => {
        this.$message.success('任务更新成功！')
        done()
        this.loadData()
      })
    },
    rowDel(row, index) {
      this.$confirm('确定删除?', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        var formData = new window.FormData()
        formData.append('id', row.id)
        formData.append('rwzt', 3)
        this.$http.post('/fighter-workflow-saas/RwManage/updateYjrw', formData).then(response => {
          this.$message.success('删除成功')
          this.loadData()
        }).catch(error => {
          this.$message.error(error.msg)
        })
      }).catch(e => { })
    },
    closeRw(id, rwzt) {
      var formData = new window.FormData()
      formData.append('id', id)
      formData.append('rwzt', rwzt + '')
      this.$http.post('/fighter-workflow-saas/RwManage/updateYjrw', formData).then(response => {
        this.$message.success('任务更新成功！')
      })
    }
  }
}
</script>
